import { useEffect, useState } from "react";
import {
  isGeneratorListSettled,
  type GeneratorAccessForAnalytics,
} from "@/utils/analyticsGeneratorName";

/** Teto da espera pela lista de geradores: page_view atrasado nunca vira page_view perdido. */
export const ANALYTICS_IDENTITY_TIMEOUT_MS = 5000;

interface ProfileForIdentity {
  user_id: string;
  is_internal: boolean;
  generator_id: number | null;
}

/**
 * `true` quando a identidade do GA4 pode ir com o nome do gerador (ver `isGeneratorListSettled`).
 *
 * A lista vem do `Layout`, que só monta em rota autenticada; numa rota fora dele ela não chegaria
 * nunca. Por isso a espera tem teto: passado o tempo, segue sem o nome da API (fica o do Supabase).
 */
export const useAnalyticsIdentityReady = (
  profile: ProfileForIdentity | null,
  access: Pick<GeneratorAccessForAnalytics, "fetchedAt" | "error">,
): boolean => {
  const settled = profile != null && isGeneratorListSettled(profile, access);
  // por usuário: trocar de conta na mesma aba volta a esperar a lista do novo usuário
  const [timedOutFor, setTimedOutFor] = useState<string | null>(null);

  const waitingFor = profile != null && !settled ? profile.user_id : null;
  useEffect(() => {
    if (waitingFor == null) return;
    const timer = setTimeout(() => setTimedOutFor(waitingFor), ANALYTICS_IDENTITY_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [waitingFor]);

  return settled || (profile != null && timedOutFor === profile.user_id);
};
